export const enum ParticipantCounter {
    Home = 1,
    Away = 2
}

export const enum ParticipantType {
    Team = 'team',
    Person = 'person',
    Double = 'double'
}

export const enum ParticipantGender {
    Male = 'male',
    Female = 'female',
    Mixed = 'mixed'
}

export const enum ParticipantNational {
    Yes = 'yes',
    No = 'no'
}

export const enum ParticipantLogo {
    Yes = 'yes',
    No = 'no'
}

export const enum Side {
    Home = 'home',
    Away = 'away'
}

export interface ParticipantInformation {
    id: number
    name: string
    area_id: number
    area_name: string
}

export interface DoubleParticipantInformation {
    participant_a: ParticipantInformation
    participant_b: ParticipantInformation
}

export interface BaseParticipant {
    short_name: string
    acronym: string
    counter?: ParticipantCounter | number
    type: ParticipantType
    gender: ParticipantGender
    area_id: number
    area_name: string
    area_code: string
    sport_id: number
    sport_name: string
    national: ParticipantNational
    shirt_nr: '' | string
    slug: string
    logo: ParticipantLogo

    // Augmented props:
    logo_url: string
}

export interface Participant extends BaseParticipant {
    id: number
}
